import classNames from 'classnames/bind'
import { Element } from 'react-scroll'

const FormControlWrapper = props => (
  <div id={`field-${props.id}`}
    className={classNames({
      'field': true,
      'is-horizontal': props.horizontal,
      'with-error': props.error
    })}
  >
    {
      props.label &&
      <div className={classNames({
        'field-label grow-2 has-text-left': true,
        [`is-${props.size}`]: props.size
      })}>
        <label className="label">{props.label}</label>
      </div>
    }
    {
      props.labelOffset &&
      <div
        className={classNames({
          'field-label grow-2': true,
          [`is-${props.size}`]: props.size
        })}
      >
        <label className="label">&nbsp;</label>
      </div>
    }
    <div className="field-body">
      <div className="field">
        <Element
          className={classNames({
            'control': true,
            'has-icons-left': props.icon
          })}
          name={props.name}
        >
          {props.children}
        </Element>
        {
          props.help && !props.error && <p className="help">{props.help}</p>
        }
        {
          props.error &&
          <p className="help is-danger">{props.error}</p>
        }
      </div>
    </div>
  </div>
)

FormControlWrapper.defaultProps = {
  disabled: false,
  size: 'small'
}

export default FormControlWrapper



// WEBPACK FOOTER //
// ./components/uiLib/FormControlWrapper/HorizontalWrapper.jsx